<div class="content-wrapper bg-white rounded-3 p-3 pt-2 pb-0 me-3 ms-3"
  [ngStyle]="{'height': scrHeight, 'overflow-y': 'auto'}">
  <form [formGroup]="projectForm">

    <div class="d-flex flex-row justify-content-between align-items-center mb-3">
       <div style="color:#cc0000">Select Project Name</div>
      <!-- <h5 class="mb-0">Project Details</h5> -->
      <div class="alert alert-info d-flex align-items-center py-1 px-3 mb-0" role="alert">
        <mat-icon class="me-2 alert-info-icon">info</mat-icon>
        <span class="small">All fields marked with<span class="text-danger fw-bold"> * </span>are required to proceed to
          the next step</span>
      </div>
    </div>


    <div>
      <!-- Naming selection (Standard vs Custom) -->
      <!-- <div class="row g-3 mb-2">
        <div class="col-12 col-md-6">
          <div class="card h-100 cursor-pointer"
            [ngClass]="{'border-danger border-2 bg-danger-subtle': naming === 'standard','text-muted': naming !== 'standard'}"
            (click)="selectNaming('standard')">
            <div class="card-body d-flex align-items-center">
              <span class="material-icons rounded p-2 me-3"
                [ngClass]="{'bg-danger-subtle text-danger': naming === 'standard','bg-light text-secondary': naming !== 'standard'}">
                tag
              </span>
              <div>
                <label for="standard-naming" class="form-label mb-0 fw-semibold">Standard Naming</label>
                <p class="small text-muted mb-0">Auto generated form model details</p>
              </div>
            </div>
          </div>
        </div>


        <div class="col-12 col-md-6">
          <div class="card h-100 cursor-pointer"
            [ngClass]="{'border-danger border-2 bg-danger-subtle': naming === 'custom','text-muted': naming !== 'custom'}"
            (click)="selectNaming('custom')">
            <div class="card-body d-flex align-items-center">
              <span class="material-icons rounded p-2 me-3"
                [ngClass]="{'bg-danger-subtle text-danger': naming === 'custom','bg-light text-secondary': naming !== 'custom'}">
                description
              </span>
              <div>
                <label for="custom-naming" class="form-label mb-0 fw-semibold">Custom Naming</label>
                <p class="small text-muted mb-0">Define your own project name</p>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- Conditionally rendered fields based on Standard or Custom naming -->
      <div class="row g-3">
        <div class="col-12">
          <!-- Project Selection Section -->
          <div class="project-select-container mb-4" *ngIf="!projectMasterIdControl.value || isEditingProject">
            <div class="d-flex align-items-center mb-3">
              <mat-icon class="me-2 align-content-center" style="color: #cc0000;">work_outline</mat-icon>
              <label class="form-label mb-0 fw-semibold" style="color: #cc0000; font-size: 15px;">Project name <span class="text-danger">*</span></label>
            </div>
            
            <div class="projects-grid">
              @for(project of projects; track project.project_id) {
                <div class="project-card" 
                  [class.selected]="projectMasterIdControl.value == project.project_id"
                  (click)="selectProjectCard(project)"
                  [matTooltip]="project.color_name || 'No color name'"
                  matTooltipPosition="above">
                  <div class="project-card-header">
                    <span class="color-swatch" [style.background-color]="project.color_code"></span>
                    <div class="project-info">
                      <div class="project-card-name">{{ project.project_name }}</div>
                    </div>
                  </div>
                </div>
              }
            </div>
            
            <div *ngIf="projectMasterIdControl.invalid && (projectMasterIdControl.dirty || projectMasterIdControl.touched)"
              class="text-danger small mt-2">
              Please select the project name
            </div>
          </div>

          <!-- Selected Project Summary and Change Button -->
          <div class="selected-project-display mt-4" *ngIf="projectMasterIdControl.value && !isEditingProject">
            <div class="selected-project-summary">
              <div class="summary-card">
                <div class="summary-row">
                  <div>
                    <label class="summary-label">Selected Project</label>
                    <div class="summary-value">
                      <span class="color-swatch small" [style.background-color]="selectedProjectColor || '#E5E7EB'"></span>
                      <span>{{ projectForm.get('projectName')?.value || 'N/A' }}</span>
                    </div>
                  </div>
                  <div>
                    <label class="summary-label">Color Name</label>
                    <div class="summary-value">{{ getSelectedProjectColorName() }}</div>
                  </div>
                  <button type="button" class="btn-change-project" (click)="toggleEditProject()">
                    <mat-icon>edit</mat-icon>
                    Change Project
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Other Form Fields - Only visible after project selection -->
        <div class="col-12" *ngIf="projectMasterIdControl.value">
          <div class="divider-section mb-4"></div>
          <div class="row g-3">
            <div class="col-12 col-lg-6">
              <div class="mb-2 position-relative">
                <div class="d-flex align-items-center mb-2">
                  <mat-icon class="me-2 align-content-center" style="font-size: 22px;">person_outline</mat-icon>
                  <label for="cnra-name" class="form-label mb-0 align-items-center d-flex">
                    Contact Person <span class="text-danger">*</span>
                  </label>
                </div>

                <div class="search-container">
                  <i class="material-icons search-icon" *ngIf="!cnraLoading">search</i>
                  <div class="spinner-border spinner-border-sm text-danger me-2" *ngIf="cnraLoading" role="status"
                    aria-hidden="true"></div>
                  <input type="text" id="cnra-name" class="search-box" formControlName="contactPerson"
                    placeholder="Search by email or name..." required [value]="cnraSearchText"
                    (input)="onCnraInput($event.target.value)" (blur)="onCnraBlur()" autocomplete="off"
                    aria-label="Search CNRA Contact Person" />
                </div>

                <!-- Suggestions dropdown: Only show if results exist -->
                <ul *ngIf="cnraShowList && cnraResults.length > 0" class="list-group position-absolute w-100 mt-1"
                  style="z-index: 1000; max-height: 240px; overflow-y: auto;">
                  <li *ngFor="let item of cnraResults" class="list-group-item list-group-item-action"
                    (mousedown)="selectCnra(item)" style="cursor: pointer;">
                    <!-- Use component-calculated flag: when email-like show ONLY email, otherwise show name -->
                    <ng-container *ngIf="cnraQueryIsEmailLike; else nameOnly">
                      <div>{{ item.cnra_email }}</div>
                    </ng-container>
                    <ng-template #nameOnly>
                      <div>{{ item.cnra_name }}</div>
                    </ng-template>
                  </li>
                </ul>

                <!-- Inline message when search produced no results -->
                <div *ngIf="cnraShowList && cnraResults.length === 0 && cnraSearched" class="text-danger small mt-1">
                  Data not found
                </div>
              </div>

              <div class="mb-2">
                <div class="d-flex align-items-center mb-2">
                  <mat-icon class="me-2 align-content-center">date_range</mat-icon>
                  <label for="due-date" class="form-label mb-0 align-items-center d-flex">Due Date <span
                      class="text-danger">*</span></label>
                </div>
                <div class="datepicker-container">
                  <input class="input-date" matInput [matDatepicker]="picker" [min]="minDate" id="dueDate"
                    formControlName="dueDate" placeholder="mm/dd/yyyy" required>
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="mb-2">
                <div class="d-flex align-items-center mb-2">
                  <mat-icon class="me-2 align-content-center">assignment</mat-icon>
                  <label for="instruction-type" class="form-label mb-0 align-items-center d-flex">Instruction Type <span
                      class="text-danger">*</span></label>

                </div>
                <select id="instruction-type" formControlName="instructionType" required class="form-select">
                  <option value="">Select instruction type</option>
                  <option value="Tech Notice">Tech Notice</option>
                  <option value="Shanin">Shanin</option>
                  <option value="Email">Email</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              <div class="mb-2">
                <div class="d-flex align-items-center mb-2">
                  <span class="material-icons me-2 align-content-center">tag</span>
                  <label for="document-number" class="form-label mb-0 align-items-center d-flex">Reference Number <span
                      class="text-danger">*</span></label>
                </div>
                <input type="text" id="document-number" formControlName="documentNumber" class="form-control"
                  placeholder="Enter reference number" (input)="onInputValueChange($event)" required>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<app-tutorial-video-widget
  [screenId]="isCopyMode ? 'copy-collection' : 'create-collection'"
  [title]="isCopyMode ? 'Copy Collection walkthrough' : 'Create Collection walkthrough'"
  teaserDescription="Watch a quick walkthrough of this screen."
  [storageKey]="isCopyMode ? 'copy-collection-tutorial-seen' : 'create-collection-tutorial-seen'"
  teaserPosition="bottom-left"
  launcherPosition="bottom-left"
  [autoPlaySequence]="adminTutorialSequence"
  [allowLauncherDismiss]="true">
</app-tutorial-video-widget>